import { render, staticRenderFns } from "./_size.vue?vue&type=template&id=5b5a390f&"
import script from "./_size.vue?vue&type=script&lang=js&"
export * from "./_size.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports